import { capitalizeString } from '@/utils/capitalizeString';
import { MediaPlaylist } from './types';

export const filterTechTagsFromMediaTags = (tags: string[]) => {
  return tags.filter((tag: string) => ![':', 'test'].some((part) => tag.includes(part)));
};

export const extractTagsFromPlaylist = (playlist: MediaPlaylist) => {
  return filterTechTagsFromMediaTags(playlist.tags.split(',')).map((category: string) => ({
    value: capitalizeString(category),
    link: { href: `/video/tag/${category}` },
  }));
};
